export { default, getStaticProps } from "app/couverture-reseau/page";
